//region [IMPORT]

// === CONSTANTS ===
import { FAILURE_CODE, SUCCESS_CODE } from "constants/general";

//#endregion

//#region [VALUES]

//#endregion

//-----------------------------------------------------------------
function validate(content, validation_info, field_type) {
  //-----------------------------------------------------------------
  function toBoolean(str) {
    if (str === true) return true;
    if (!str) return false;

    const enabled = ['1', 'true', 'yes', 'ja', 'on'];
    return enabled.includes(String(str).toLowerCase());
  }

  const result = {
    content,
    status: SUCCESS_CODE,
  }

  // --- VALIDATION ---

  if (field_type === 'min') {
    // Test formatted (7-10-1) or raw (18 digits) format if Strip is not enabled
    if (!toBoolean(validation_info?.Strip)) {
      const formattedPattern = /^\d{7}-\d{10}-\d$/;
      const rawPattern = /^\d{18}$/;

      if (!(formattedPattern.test(result.content) || rawPattern.test(result.content))) {
        result.status = FAILURE_CODE;
        result.message = 'Invalid MIN format';
        return result;
      }
    }

    const digits = (result.content || '').replace(/\D/g, '');

    // MIN must be exactly 18 digits
    if (digits.length !== 18) {
      result.status = FAILURE_CODE;
      result.message = 'Invalid MIN: must be exactly 18 digits';
      return result;
    }

    const payload = digits.split('').map(d => parseInt(d, 10));

    // First 17 digits are the payload, last digit is the check digit
    const checkDigit = payload[17];
    let sum = 0;

    for (let i = 16; i >= 0; i--) {
      let digit = payload[i];

      // MERS Mod10 (Luhn-style) — double every second digit moving right-to-left
      if (i % 2 === 0) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }

      sum += digit;
    }

    // remainder of sum/10
    const expectedCheckDigit = (10 - (sum % 10)) % 10;

    if (expectedCheckDigit !== checkDigit) {
      result.status = FAILURE_CODE;
      //console.log('Expected check digit:', expectedCheckDigit, 'Actual check digit:', checkDigit, 'Sum:', sum);
      result.message = 'Invalid MIN: checksum failed';
    }

    if(toBoolean( validation_info?.Strip ))
      result.content = digits;
  }

  console.log('Validation result:', result);
  return result;
};

//#endregion

export { validate }